import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSpacesMastheadExternalServer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="spaces-masthead-external-server_svg__Layer_1"
    x={0}
    y={0}
    width={60}
    height={60}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <style>
      {
        ".spaces-masthead-external-server_svg__st0{fill:#6e6f72}.spaces-masthead-external-server_svg__st1{fill:#b3b3b5}"
      }
    </style>
    <path
      className="spaces-masthead-external-server_svg__st0"
      d="M43 23v13H2V23h41m0-1H2c-.6 0-1 .4-1 1v13c0 .6.4 1 1 1h41c.6 0 1-.4 1-1V23c0-.5-.5-1-1-1z"
    />
    <path
      className="spaces-masthead-external-server_svg__st0"
      d="M43 37v13H2V37h41m0-1H2c-.6 0-1 .4-1 1v13c0 .6.4 1 1 1h41c.6 0 1-.4 1-1V37c0-.5-.5-1-1-1zM43 9v13H2V9h41m0-1H2c-.6 0-1 .4-1 1v13c0 .6.4 1 1 1h41c.6 0 1-.4 1-1V9c0-.6-.5-1-1-1z"
    />
    <path
      className="spaces-masthead-external-server_svg__st1"
      d="M27 14h10v3H27zM27 28h10v3H27zM27 42h10v3H27z"
    />
  </svg>
);
const Memo = memo(SvgSpacesMastheadExternalServer);
export default Memo;
